if (window.innerWidth < 700 && $('#navbar-toggle').length) {
    $('#navbar-toggle').click(function () {
        if ($(this).hasClass('is-active')) {
            $(this).removeClass('is-active').attr('aria-expanded', 'false');
            $('.c-blog-nav__list').slideUp();
        } else {
            $(this).addClass('is-active').attr('aria-expanded', 'true');;
            $('.c-blog-nav__list').slideDown();
        }
    });
}